import { axios } from "../axios";

export const GetUserFiles = (id: number) => {
    return axios.get(`saved_files?user=${id}`);
}
export const AddUserFile = (formdata) => {
    return axios.post(`enregistrer`, formdata, { headers: { "Content-Type": "multipart/form-data" } });
}